import { useThree } from '@react-three/fiber'
import { useAppStore } from '@store'
import { toVector3 } from '@utils/conversion/toVector3'
import { useEffect } from 'react'

export function useCachedCamera3D() {
  const { raycaster, controls } = useThree()
  const setCamera3D = useAppStore((store) => store.setCamera3D)
  const setCamera2DPosition = useAppStore((store) => store.setCamera2DPosition)
  const isModalOpen = useAppStore.use.isModalOpen()
  const shouldUpdateCamera = useAppStore.use.shouldUpdateCamera()
  useEffect(() => {
    //return () => {
    if (isModalOpen || !shouldUpdateCamera) return
    if (raycaster?.camera?.isPerspectiveCamera && controls) {
      const lookAt = toVector3()
      raycaster.camera?.getWorldDirection(lookAt)
      const data = {
        position: raycaster.camera?.position,
        matrix: raycaster.camera?.matrix,
        lookAt,
      }
      setCamera3D(data)
    } else if (raycaster?.camera?.isOrthographicCamera) {
      const data = {
        position: raycaster.camera.position.toArray(),
        zoom: raycaster.camera.zoom,
        bottom: raycaster.camera.bottom,
        frustrumCulled: raycaster.camera.frustrumCulled,
        matrix: raycaster.camera.matrix,
        matrixWorld: raycaster.camera.matrixWorld,
        top: raycaster.camera.top,
      }
      setCamera2DPosition(data)
    }
    // }
  }, [])
}
